import { inApp, isAndroid, isHarmony, isInKd, isiOS, vc } from '@k/system';
import { hybrid } from 'hybrid-sdk-common';
import urlExt from '@/kits/url';
import cookie from '@k/cookie';
import { Toast } from '@upc/vant';
import wakeUpAppLinks from './wakeupAppLinks';
import AppLinks from '@/kits/appLinks';

export async function getAppStatus(): Promise<boolean> {
  let installedDx = false;
  if (isAndroid || isiOS) {
    const { isInstalled } = await new Promise(resolve =>
      hybrid('core_isAppInstalled', { url: isAndroid ? 'com.zmzx.college.search' : 'dxst://' }, resolve)
    );
    if (isInstalled) {
      installedDx = true;
    }
  }

  return installedDx;
}

export async function getWakeupAppStatus(): Promise<boolean> {
  let installedWakeup = false;
  if (isAndroid || isiOS) {
    const { isInstalled } = await new Promise(resolve =>
      hybrid('core_isAppInstalled', { url: isAndroid ? 'com.suda.yzune.wakeupschedule' : 'wakeupschedule://' }, resolve)
    );
    if (isInstalled) {
      installedWakeup = true;
    }
  }

  return installedWakeup;
}

export function isTips(): boolean {
  console.log('isTips', urlExt.getQuery('__tips__'));
  console.log('isTips cookie:', cookie.getRaw('__tips__'));

  if (Number(urlExt.getQuery('__tips__')) == 1 || Number(cookie.getRaw('__tips__')) == 1) {
    return true;
  }
  return false;
}

export function tipsSuffix(): string {
  return isTips() ? '&__tips__=1' : '';
}

export function hideLogoLoading(): void {
  if (!vc || Number(vc) < 970) return;
  hybrid('hideLogoLoading');
}

// 获取快对状态栏高度
export const getKDStaBarTopHeight = async (): Promise<number> => {
  let staBarHeight = 0;
  try {
    const { height } = await hybrid(isiOS ? 'navbarHeight' : 'webviewTopHeight');
    const dpr = window.devicePixelRatio || 1;
    staBarHeight = (Number(height) / dpr) | 0;
  } catch (error) {
    console.log(error, 'error');
  }
  return staBarHeight as number;
};

export const getLocationId = (location: string): number => {
  // 1（首页弹窗），2（大金刚），3（引导语），4（首页 banner）5（拍搜）6(小金刚) 7(wakeup我的页banner) 8(wakeup首页顶部icon)
  switch (location) {
    case 'home':
      return 1;
    case 'vajra':
      return 2;
    case 'guide':
      return 3;
    case 'banner':
      return 4;
    case 'paisou':
      return 5;
    case 'smallvajra':
      return 6;
    case 'pcbanner':
      return 7;
    case 'pcicon':
      return 8;
    default:
      return 5;
  }
};

export const isInHomeWork = /homework/i.test(navigator.userAgent);

export const toast = (text: string): void => {
  if (inApp || isInHomeWork || isInKd) {
    hybrid('toast', { text });
  } else {
    Toast(text);
  }
};

export const copyText = (text: string): void => {
  if (inApp || isInKd) {
    hybrid('pasteBoard', {
      content: text,
      toastHide: 0,
      toastText: '复制成功'
    });
  } else if (isInHomeWork) {
    hybrid('copyToClipboard', {
      content: text,
      hint: '复制成功'
    });
  }
};

export const gotoWakeup = async (): Promise<void> => {
  const knowInstalled = await getWakeupAppStatus();
  const App = new wakeUpAppLinks({
    knowInstalled: +knowInstalled,
    isTip: false
  });
  App.active();
};

/**
 * 跳转大学
 * @param jumpUrl url，默认首页
 */
export const gotoCollege = async (jumpUrl = 'dxst://com.zmzx.college.search/main/home'): Promise<void> => {
  const knowInstalled = await getAppStatus();
  const App = new AppLinks({
    knowInstalled: +knowInstalled,
    downloadLink: isHarmony
      ? 'https://appgallery.huawei.com/#/app/C102506411'
      : `https://download.daxuesoutijiang.com/app/static/com_zmzx_college_search/zuoyebang_androidPhone_dxstj_download_common_00.apk`,
    nativeLinkIos: jumpUrl,
    nativeLinkAndroid: jumpUrl,
    isTip: false // 唤起大学时，不再展示端上弹窗
  });
  App.active();
};

/**
 * 获取真实px
 * @param px 设计稿px
 * @returns 真实渲染px
 */
export function getRealPx(px: number): number {
  const screenWidth = window.innerWidth;
  const designWidth = 720;
  return (px / designWidth) * screenWidth;
}
